const stepperStyles = (theme) => ({
  stepper: {
    background: "initial",
    padding: 0,
    flex: "2 1 auto",
    flexWrap: "wrap",
    alignContent: "space-between",
  },
  link: {
    color: theme.palette.text.primary,
    textDecoration: "none",
  },
  active: {
    fontWeight: "bold",
  },
  steps: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .MuiStepper-root": {},
  },
  buttonsContainer: {
    display: "flex",
    minWidth: 120,
    justifyContent: "space-evenly",
  },
  buttonsContainerBig: {
    minWidth: 150,
  },
  hidden: {
    visibility: "hidden",
    width: 0,
    padding: 0,
  },
  button: {
    padding: 0,
    minWidth: 50,
  },
  bigButton: {
    padding: theme.spacing(0.5, 1.25),
    minWidth: 64,
  },
});

export default stepperStyles;
